import { get } from "./apiClient";

export default {
  async getBadgesByCustomerId(customerId) {
    return await get(`Badges/${encodeURIComponent(customerId)}`);
  }
};
